/**
 * Spacing scale. Fixed-pixel values keep gutters and gaps on a shared
 * metric across the admin surface regardless of viewport size.
 */
export const space = {
    0: "0",
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    5: "20px",
    6: "24px",
    7: "32px",
    8: "40px",
    9: "48px",
    10: "64px",
} as const;

export type SpaceKey = keyof typeof space;
